// extracted by mini-css-extract-plugin
export default {"btn":"Search_btn__k6xdL"};